import qz from "qz-tray";
import {useEffect} from "react";

qz.websocket.connect({host: "localhost", ports: [8181, 8282, 8383, 8484, 9100], secure: false})
    .then(() => console.log("Connected to QZ Tray"))
    .catch(err => console.error("QZ Tray connection failed:", err));

const PrintComponent = () => {
    const testFxn = async () => {
        try {
            if (!qz.websocket.isActive()) {
                await qz.websocket.connect({host: 'localhost', ports: [8181, 8282, 8383, 8484], secure: false});
                console.log("✅ Connected to QZ Tray");
            } else {
                console.log("Already connected");
            }
        } catch (err) {
            console.error("❌ Unable to connect to QZ:", err);
            alert("❌ QZ Tray not running or blocked. Please start QZ Tray.");
        }
    }

    useEffect(() => {
        testFxn().then()
    }, [])

    const printViaTCP = async () => {
        try {
            // Connect to QZ Tray
            await qz.websocket.connect();

            // 🔹 Printer TCP interface setup (not by name, but by IP)
            const config = qz.configs.create(null, {
                host: "192.168.1.50", // 🖨️ Printer IP
                port: 9100,            // Default ESC/POS port
                encoding: "UTF-8",
                protocol: "socket",    // Use TCP socket mode
            });

            // 🔹 ESC/POS raw data
            const data = [
                '\x1B\x40',              // Initialize printer
                '*** TEST RECEIPT ***\n',
                'Hello from QZ Tray!\n',
                '\n\n\n',
                '\x1D\x56\x00'           // Cut paper
            ];

            // 🔹 Send to printer
            await qz.print(config, data);

            // Disconnect
            await qz.websocket.disconnect();

            alert("✅ Printed successfully!");
        } catch (err) {
            console.error("Print error:", err);
            alert("❌ " + err.message);
        }
    };

    return (
        <div>
            <a onClick={printViaTCP}>Test Print</a>
        </div>
    )
}
export default PrintComponent
